import { render } from "./BotaoSiop.vue?vue&type=template&id=363da974"
import script from "./BotaoSiop.vue?vue&type=script&lang=js"
export * from "./BotaoSiop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__